module.exports = __webpack_public_path__ + "img/carrousel-video-8.d4b00d70.png";